<template>
    <ChartLayout :showEmptyChart="showEmptyChart" infoRef='info-subject-areas'>
        <template #title><span v-html="$t('OrganizationReport.courses_watched_in_different_subject_areas')"></span></template>
        <template #tooltip>
            <div class="chart-tooltip">
                <ol :class="['chart-tooltip__list', { 'two-columns': sortedTooltipData.length > 15 }]">
                    <li v-for="(item, index) in sortedTooltipData" :key="index" class="chart-tooltip__list-item">
                        {{ item.name }} - <span class="chart-tooltip__time">{{ item.totalMinutesWatched }}</span>
                    </li>
                </ol>
                <span class="chart-tooltip__note" v-html="$t('OrganizationReport.subject_area_tooltip_note')"></span>
            </div>
        </template>
        <ColumnChart :data="data" :categories="coursesInSubjectAreas" v-show="!showEmptyChart" />
    </ChartLayout>
</template>

<script>
    import ColumnChart from 'components/user/charts/ColumnChart'
    import ChartLayout from 'components/user/organizationreport/charts/ChartLayout'
    import { translateWithDefault } from 'helpers/i18nHelper'
    import convertMinutesToHours from 'components/shared/mixins/convertMinutesToHours'
    import emptyChartHelper from 'components/user/organizationreport/charts/helpers/emptyChartHelper'

    export default {
        name: 'courses-in-subject-areas-chart',
        components: { ColumnChart, ChartLayout },
        props: {
            graphData: {
                type: Array
            }
        },
        mixins: [convertMinutesToHours, emptyChartHelper],
        computed: {
            sortedData () {
                return this.graphData
                    .filter(data => data.totalMinutesWatched > 0)
                    .sort((a, b) => +b.totalMinutesWatched - +a.totalMinutesWatched)
            },
            sortedTooltipData () {
                return this.sortedData.map(item => {
                    return {
                        name: translateWithDefault(item.packageCode, item.packageCode),
                        totalMinutesWatched: this.convertMinutesToHours(item.totalMinutesWatched)
                    }
                })
            },
            sortedGraphData () {
                let topNineSubjectAreas = this.sortedData.slice(0, 10)
                topNineSubjectAreas = topNineSubjectAreas.filter(item => item.packageCode !== 'fi-total')
                let others = this.sortedData.slice(9, this.sortedData.length)
                let othersHoursCount = others.reduce((total, item) => total + item.totalMinutesWatched, 0)

                if (othersHoursCount > 0) {
                    return [
                        ...topNineSubjectAreas,
                        {
                            packageCode: 'OrganizationReport.others',
                            packageName: 'OrganizationReport.others',
                            totalMinutesWatched: othersHoursCount
                        }
                    ]
                }

                return topNineSubjectAreas
            },
            data () {
                return this.sortedGraphData.map(item => Math.floor(item.totalMinutesWatched))
            },
            coursesInSubjectAreas () {
                return this.sortedGraphData.map(item => translateWithDefault(item.packageCode, item.packageCode))
            }
        }
    }
</script>

<style lang="scss" scoped>
    .chart-tooltip {
        padding: 10px;

        &__list {
            margin: 0;
            padding-inline-start: 20px;

            &.two-columns {
                column-count: 2;
                column-gap: 20px;
            }
        }

        &__list-item {
            padding: 3px 30px 3px 0;
            font-family: Nunito-Regular, sans-serif;
            font-weight: 400;
            white-space: nowrap;
        }

        &__time {
            font-family: Nunito-ExtraBold, sans-serif;
            font-size: 1.3rem;
        }

        &__note {
            font-style: italic;
            font-size: 1.3rem;
            display: block;
            margin: 10px 0 0;
            font-weight: 400;
        }
    }
</style>
